// Where the /logout view goes once it has cleared the SSO tokens (#157).
//
// It never goes to a URL from its own query string: anyone can link to
// /logout with any returnTo, so following it made this page an open redirect
// and a javascript: URL sink. It goes back to the d3-auth API instead, whose
// /oauth/<tenant>/logout/complete checks returnTo against the application's
// allowed logout URLs and makes the final redirect itself.

/**
 * @param {string} search the page's location.search
 * @param {string} backendUrl the d3-auth API origin, from getBackendUrl()
 * @returns {string} the URL to continue to: the API's logout/complete, or '/'
 */
export function logoutContinueUrl(search, backendUrl) {
    const params = new URLSearchParams(search);
    const tenant = params.get('tenant');
    if (!tenant) return '/';

    const next = new URLSearchParams();
    const clientId = params.get('client_id');
    if (clientId) next.set('client_id', clientId);
    const returnTo = params.get('returnTo');
    if (returnTo) next.set('returnTo', returnTo);

    return `${backendUrl}/oauth/${encodeURIComponent(tenant)}/logout/complete?${next.toString()}`;
}
